import { render } from "./orderDetail.vue?vue&type=template&id=c5b19d56&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"

import "./orderDetail.vue?vue&type=style&index=0&id=c5b19d56&scoped=true&lang=less"

import exportComponent from "C:\\Users\\lq\\Desktop\\普康\\activity-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5b19d56"]])

export default __exports__